export class AuthServiceResult {
    statusCode: number;
    statusMessage: string;
}